import { IsNotEmpty, IsNumber, IsOneOfThese, IsValidDate } from '@core/services/csv/CSVCustomValidator'
import { CSVModelInterface } from '@core/services/csv/CSVModel.interface'
import { DateService } from '@master/services/DateService'
import { CommissionData } from '../../api'
import { Expose, Transform } from 'class-transformer'
import { ValidateIf } from 'class-validator'
import { isEmpty } from 'lodash'
import { parseFloatNumber, parseIntNumber } from '@core/services/csv/CSVTransformer'
import { FrequencyList, FrequencyToValueMapping, FrequencyType } from '@master/model/options/FrequencyOptions'
import { productTypes } from '@master/model/options/LineOfBusinessOptions'

const dateService = new DateService()

export class ManulifeTransactionCsvModel extends CSVModelInterface implements CommissionData {
  @Expose()
  @IsNotEmpty()
  private 'Agt Code' = 'CODE 123'

  get advCode () {
    return this['Agt Code']
  }

  @Expose()
  private 'Agt Name' = 'Wen Adviser'

  get advName () {
    return this['Agt Name']
  }

  @Expose()
  @IsNotEmpty()
  private 'Pol Num' = 'Policy 123'

  get policyNumber () {
    return this['Pol Num']
  }

  @Expose()
  private 'Insrd Name' = 'John Doe'

  get clientName () {
    return this['Insrd Name']
  }

  @Expose()
  private 'Plan Code' = 'ABC001'

  get componentCode () {
    return this['Plan Code']
  }

  @Expose()
  private 'Plan Name' = 'Life Insurance Name'

  get productName () {
    return this['Plan Name']
  }

  @Expose()
  @IsNotEmpty()
  @IsOneOfThese(productTypes)
  private 'Product Type' = '[' + productTypes + ']'

  get productType () {
    return this['Product Type']
  }

  @Expose()
  @ValidateIf(o => !isEmpty(o.premiumCurrency))
  @IsOneOfThese(['SGD', 'CHF', 'EUR', 'GBP', 'USD', 'AUD', 'JPY', 'HKD'])
  private 'Crcy' = 'SGD'

  get premiumCurrency () {
    return this.Crcy
  }

  @Expose()
  @Transform(({ value }) => parseFloatNumber(value))
  @IsNumber()
  private 'Prem Amt' = 123.45

  get premiumAmt () {
    return this['Prem Amt']
  }

  @Expose()
  @ValidateIf(o => !isEmpty(o.premiumPurpose))
  @IsOneOfThese(['RP', 'SP', 'RSP', 'TOP-UP'])
  private 'Prem Typ' = 'RP'

  get premiumPurpose () {
    return this['Prem Typ']
  }

  @Expose()
  @IsOneOfThese(FrequencyList.filter(frequency => !['RSP', 'Single'].includes(frequency)))
  private 'Pmt Mode' = 'Monthly'

  get payMode () {
    return FrequencyToValueMapping(this['Pmt Mode'] as FrequencyType)
  }

  @Expose()
  @Transform(({ value }) => parseIntNumber(value))
  @ValidateIf(o => !isEmpty(o.policyYear))
  @IsNumber()
  private 'Pol Year' = 13

  get policyYear () {
    return this['Pol Year']
  }

  @Expose()
  @ValidateIf(o => !isEmpty(o.approvedDate))
  @IsValidDate('DD/MM/YYYY')
  private 'Pol Iss Dt' = '31/12/2020'

  get approvedDate (): number {
    return dateService.toUnixMilliseconds(this['Pol Iss Dt'], 'DD/MM/YYYY')
  }

  @Expose()
  @ValidateIf(o => !isEmpty(o.effectiveDate))
  @IsValidDate('DD/MM/YYYY')
  private 'Pol Eff Dt' = '31/12/2020'

  get effectiveDate (): number {
    return dateService.toUnixMilliseconds(this['Pol Eff Dt'], 'DD/MM/YYYY')
  }

  @Expose()
  @ValidateIf(o => !isEmpty(o.paidToDate))
  @IsValidDate('DD/MM/YYYY')
  private 'Crr Trxn Dt' = '31/12/2020'

  get paidToDate (): number {
    return dateService.toUnixMilliseconds(this['Crr Trxn Dt'], 'DD/MM/YYYY')
  }

  @Expose()
  @Transform(({ value }) => parseFloatNumber(value))
  @IsNumber()
  private 'Comm Amt' = 123.45

  get commissionAmt () {
    return this['Comm Amt']
  }

  @Expose()
  @Transform(({ value }) => parseFloatNumber(value))
  @IsNumber()
  private 'Or Amt' = 123.45

  get orCommissionAmt () {
    return this['Or Amt']
  }
}
